export const PPWR_COMPLIANCE_STATUSES = {
    high_risk: {
        label: 'High Risk',
        color: '#EB5757',
        backgroundColor: '#FDF0F0',
        borderColor: '#F5D0D0',
    },
    medium_risk: {
        label: 'Medium Risk',
        color: '#F2994A',
        backgroundColor: '#FFF8F0',
        borderColor: '#FDE0C2',
    },
    low_risk: {
        label: 'Low Risk',
        color: '#1CBB8C',
        backgroundColor: '#E8F8F3',
        borderColor: '#C6EDE0',
    },
    compliant: {
        label: 'Compliant',
        color: '#1CBB8C',
        backgroundColor: '#E8F8F3',
        borderColor: '#C6EDE0',
    },
};

export const getPpwrComplianceStatusConfig = (status) => (
    PPWR_COMPLIANCE_STATUSES[status] || PPWR_COMPLIANCE_STATUSES.high_risk
);

export const PPWR_READINESS_KNOB_SETTINGS = {
    height: 60,
    width: 60,
    fgColor: '#00C47F',
    thickness: 0.12,
    lineCap: 'round',
};

export const PPWR_LAST_UPDATED_DATE_FORMAT = 'D MMM YYYY';

export const PPWR_RISK_CONFIG = {
    low: {
        label: 'Low Risk',
        color: 'success',
        textClass: 'text-success',
        hex: '#1CBB8C',
    },
    medium: {
        label: 'Medium Risk',
        color: 'warning',
        textClass: 'text-warning',
        hex: '#F2994A',
    },
    high: {
        label: 'High Risk',
        color: 'danger',
        textClass: 'text-danger',
        hex: '#EB5757',
    },
};

export const getPpwrRiskConfig = (riskLevel) => (
    PPWR_RISK_CONFIG[riskLevel] || PPWR_RISK_CONFIG.high
);

export const PPWR_REQUIREMENT_STATUSES = {
    completed: {
        label: 'Completed',
        isFlagged: false,
    },
    red_flag: {
        label: 'Red Flag',
        isFlagged: true,
    },
};

export const getPpwrRequirementStatusConfig = (status) => (
    PPWR_REQUIREMENT_STATUSES[status] || PPWR_REQUIREMENT_STATUSES.red_flag
);
